<template>
    <div id="deco-homes-wrapper">
        <div id="deco-portfolio">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="bg-black text-white">
                <b-container class="py-100">
                    <p class="gotham-bold">
                        BRANDING
                    </p>
                    <p class="gotham-book mb-0">
                       For any residential offering in southern Ontario's prestigious King City, location must influence design. King's Calling draws upon the inherent acclaim of this sought-after locale to create an established sense of place that welcomes Ontario's most upscale homebuyers.
                    </p>
                </b-container>
            </section>
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent"
                />
            </section>

            <section>
                <img src="/img/portfolio/kingscalling/kingscalling-luxury-forthcoming-full.jpg" alt="Kings Calling" class="d-block w-100">
            </section>

            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent2"
                />
            </section>

            <section>
                <img src="/img/portfolio/kingscalling/kingscalling-washroom-full.jpg" alt="Kings Calling - Washroom" class="d-block w-100">
            </section>

            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent3"
                />
            </section>

            <section>
                <div>
                    <b-row>
                        <b-col lg="8" class="px-0">
                            <div class="position-relative digitalads-bg">
                                <div class="gotham-book text-white h2" role="heading">
                                    ELEMENTS OF TIMELESS DESIGN
                                </div>
                                <div class="kc-logo w-100">
                                    <img src="/img/portfolio/kingscalling/kingscalling-logo-white.png" alt="King's Calling" class="w-100 d-block">
                                </div>
                            </div>
                        </b-col>
                        <b-col lg="4" class="px-0" style="background-color: #E7E4DB">
                            <div class="py-5 py-lg-0 pt-lg-0 d-lg-flex justify-content-center flex-column h-100 w-100 max-w-400 mx-auto px-5 px-lg-0 text-black">
                                <p class="gotham-bold">
                                    DIGITAL ADS
                                </p>
                                <p class="gotham-book">
                                    For such a spectacular offering, our digital advertising strategy was simple - let the visuals do the talking.
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </section>

            <section class="stipple-bg py-80">
                <div class="px-100">
                    <img src="/img/portfolio/kingscalling/KC-WEB-ADS.png" alt="Kings Calling Ads" class="w-100">
                </div>
            </section>   
            

            <section>
                <FullWidthSlider 
                :slides="firstSliderItems"
                :styles="firstSliderStyles"/>
            </section>

            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
        <!-- <div>
            <FullWidthSlider2 
            :slides="secondSliderItems"
            :styles="secondSliderStyles"/>
        </div> -->
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_decoHomes: null,
            textAnimation_decoHomes: null,
            fadeInUpElement_decoHomes: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "PROJECT IDENTITY CREATION"
                },
                {
                    name: "PRINT AD"
                },
                {
                    name: "BROCHURE DESIGN"
                },
                {
                    name: "WEBSITE DESIGN & DEVELOPMENT"
                },
                {
                    name: "WEBSITE HOSTING & MANAGEMENT"
                },
                {
                    name: "MARKETING & DIGITAL ADVERTISING"
                },
                {
                    name: "MEDIA PLANNING"
                },
                {
                    name: "INTERIOR DESIGN & DÉCOR CONSULTING"
                },
                {
                    name: "SIGNAGE DESIGN"
                },
                {
                    name: "PRODUCTION & INSTALLATION"
                },
            ],
            pageName: "KINGS CALLING",
            pageLink: "",
            linkName: "",
            sliderWithColumns: [
                {
                    img: "/img/portfolio/cetana/cetana-logo-over-green-texture.jpg",
                    alt: "Cetana",
                    imgLeft: "/img/portfolio/cetana/cetana-grey-logo-green-bg.jpg",
                    imgRight: "/img/portfolio/cetana/cetana-white-logo-orange-bg.jpg",
                }
            ],
            sliderWithColumnsStyles: {
                bgColor: '#e7e4dc',
                textColor: '#000',
                sliderClass: 'slider-dots-black',
                imgOnLeftSide: true,
                heading: "LOGO",
                desc: "Stylish, subtle, yet substantial, the King's Calling logo reflects the individuals and families who call this signature community home. It's an expression of tasteful elegance that reminds homeowners of their highest aspirations.",
                subheading: ''
            },
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-1.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-2.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-3.jpg",
                    alt: "DECO Magazie"
                }
            ],
            firstSliderStyles: {
                bgColor: '#41695b',
                textColor: '#fff',
                sliderClass: false,
                imgOnLeftSide: false,
                heading: "BROCHURE",
                desc: "The King's Calling brochure wasn't designed to be brochure at all. Instead, it was created to be a decor piece future homeowners would proudly display. Each homeowner was given a copy personal copy as a little thank-you from the builders.",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: false,
                    alt: "Cetana - Here For The Future",
                    video: "/videos/Kingscallingbrochure.mp4"
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                textBackgroundImg: 'stipple-bg',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-black',
                sliderClass: false,
                heading: "GUERILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                imgPadding: false,
                bgColor: '#E7E4DB',
                bgImageClass: "",
                textColor: "#000",
                img: "/img/portfolio/kingscalling/kingscalling-slide.jpg",
                alt: "Kings Calling",
                heading: "LOGO",
                desc: "Stylish, subtle, yet substantial, the King's Calling logo reflects the individuals and families who call this signature community home. It's anexpression of tasteful elegance that reminds homeowners of their highest aspirations."
            },
            imageAndTextContent2: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#E7E4DB',
                bgImageClass: "",
                textColor: "#000",
                img: "/img/portfolio/kingscalling/kingscalling-model.jpg",
                alt: "Kings Calling",
                heading: "RENDERINGS",
                desc: "King's Calling offers a marvelous collection of distinctive estate residences. Our expert rendering team poured over every architectural and design detail to bring this unique vision to life."
            },
            imageAndTextContent3: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#24272a',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/kingscalling/kingscalling-booklet.jpg",
                alt: "Kings Calling",
                heading: "PRINT ADS",
                desc: "Every piece of ad material works in concert to create a cohesive brand narrative. It's a symphony of information and inspiration that persuaded our target market to discover the King's Calling story for themselves."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#e7e4dc',
                bgImageClass: "",
                textColor: "#000",
                img: "/img/portfolio/deco/deco-tiktok-placeholder.jpg",
                alt: "DECO Magazine Design Trends",
                heading: "SOCIAL MEDIA",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna"
            },
            nextProject: {
                link: "/portfolio/southport",
                name: "Southport"
            }
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSliderWithColumns: () => import('@/components/FullWidthSliderWithColumns'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_decoHomes();
            // 
            this.initImgElReveal_decoHomes();
            this.initTextReveal_decoHomes();
        }, 500)
    },
    methods: {
        initscrollSmoother_decoHomes() {
            this.scrollSmoother_decoHomes = ScrollSmoother.create({
                wrapper: '#deco-homes-wrapper',
                content: "#deco-portfolio",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_decoHomes.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_decoHomes() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_decoHomes = this.fadeInUpElement_decoHomes;
                fadeInUpElement_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_decoHomes.set(container, { autoAlpha: 1 });
                fadeInUpElement_decoHomes.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_decoHomes() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_decoHomes = this.textAnimation_decoHomes;
                textAnimation_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_decoHomes.set(container, { autoAlpha: 1 });
                textAnimation_decoHomes.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_decoHomes.kill();
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

.digitalads-bg {
    background-image: url('/img/portfolio/kingscalling/kingscalling-digital-ads.jpg');
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 640px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.kc-logo {
    max-width: 240px;
    position: absolute;
    bottom: 40px;
}
</style>